import { validations } from './validations';

/**
 * Questions about beer consumption patterns and relationship with beer
 */
export const beerConsumptionQuestions = [
  {
    id: 'beer-relationship',
    question: 'Além de consumir, você tem alguma outra relação com a cerveja? ',
    subtitle: 'Assinale até 3',
    type: 'checkbox',
    options: [
      { value: 'nenhuma', label: 'NENHUMA' },
      { value: 'cervejeiro caseiro (produz cerveja em casa)', label: 'Cervejeiro caseiro (produz cerveja em casa)' },
      { value: 'cervejeiro profissional (trabalha na produção em cervejaria)', label: 'Cervejeiro profissional (Trabalha na produção em cervejaria)' },
      { value: 'atua em cervejaria (fora da produção)', label: 'Atua em cervejaria (fora da produção)' },
      { value: 'atua em fornecedores do setor (insumos, equipamentos e serviços para cervejarias).', label: 'Atua em fornecedores do setor (insumos, equipamentos e serviços para cervejarias).' },
      { value: 'dono de cervejaria', label: 'Dono de cervejaria' },
      { value: 'dono de estabelecimento (bar, pdv, restaurante)', label: 'Dono de estabelecimento (Bar, PDV, Restaurante)' },
      { value: 'comunicador/influencer', label: 'Comunicador / Influencer' },
      { value: 'sommelier profissional', label: 'Sommelier profissional' },
      { value: 'vendedor/distribuidor', label: 'Vendedor / Distribuidor' },
    ],
    minSelections: 1,
    maxSelections: 3,
    exclusiveOptions: ['nenhuma'],
    validation: validations.checkboxMinMax(1, 3)
  },
  {
    id: 'other-drinks',
    question: 'Além de cervejas, você consome outro tipo de bebida alcoólica?',
    type: 'checkbox',
    options: [
      { value: 'não bebo nada além da cerveja', label: 'Não bebo nada além da cerveja' },
      { value: 'drinks (ex.: negroni, cosmopolitan)', label: 'Drinks (ex.: Negroni, Cosmopolitan)' },
      { value: 'drinks em lata (ex.: beats, ice)', label: 'Drinks em lata (ex.: Beats, Ice)' },
      { value: 'cachaça', label: 'Cachaça' },
      { value: 'espumante', label: 'Espumante' },
      { value: 'gim', label: 'Gim' },
      { value: 'hidromel', label: 'Hidromel' },
      { value: 'licor', label: 'Licor' },
      { value: 'sidra', label: 'Sidra' },
      { value: 'tequila', label: 'Tequila' },
      { value: 'vinho', label: 'Vinho' },
      { value: 'vodka', label: 'Vodka' },
      { value: 'whisky', label: 'Whisky' },
    ],
    exclusiveOptions: ['não bebo nada além da cerveja'],
    validation: validations.required
  },
];
